module.exports = __webpack_public_path__ + "f31eca9b.svg";